import React from 'react';

const NotFound = () => (
  <div className="main-content not-found">
    <i className="material-icons icn-error">error_outline</i>
    <h2>Page Not Found</h2>
  </div>
);

export default NotFound;


// WEBPACK FOOTER //
// ./src/components/NotFound.js